import { useState } from "react";
import { IRoadFeatureListItemProps } from "./RoadFeatureResponseList";
import { Collapse, Divider, ListItemButton, ListItemText } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { MissingBruksklasseItem } from "../../RouteDescription/MissingBruksklasse";
import { RoadFeaturesWithBruksklasse } from "../../../services/RuteplanAPI";

export default function MissingBruksklasseListItem(props: IRoadFeatureListItemProps) {
  const [open, setOpen] = useState(false);

  const onClick = () => {
        setOpen((prevstate) => !prevstate);
  };

  const roadFeatureResponse = props.roadFeatureResponse as RoadFeaturesWithBruksklasse;
  
  
  return(
    <>
    {roadFeatureResponse && roadFeatureResponse.missingBruksklasser && roadFeatureResponse.missingBruksklasser.length > 0 && (
      <>
      <ListItemButton
      onClick={onClick}>
        <ListItemText primary={`Manglende bruksklasser (${roadFeatureResponse.missingBruksklasser.length})`}/> 
        {open ? <ExpandLess /> : <ExpandMore />} 
      </ListItemButton>
      <Collapse
      in={open}
      timeout="auto" 
      unmountOnExit
      >
        <MissingBruksklasseItem roadFeatures={roadFeatureResponse} onClick={props.onClick} onMouseEnterItem={props.onMouseEnterItem} onMouseLeaveItem={props.onMouseLeaveItem}/>
      </Collapse>
      <Divider />
      </>
    )}
    
    </>
  )
}